<div class="title">{{ 'columns.trafficType' | translate }}</div>

<div class="radio-button">
	<alaris-radio
		[alarisComplexTooltip]="tooltipPriorityComponent"
		[attr.data-testid]="'priorityRadio/' + MessagePurpose.TRANSACTION"
		[componentData]="MessagePurpose.TRANSACTION"
		[formControl]="control"
		[id]="'Transaction'"
		[value]="MessagePurpose.TRANSACTION"
		name="priority"
	>
		{{ 'enums.' + MessagePurpose.TRANSACTION | translate }}
	</alaris-radio>
	<alaris-radio
		[alarisComplexTooltip]="tooltipPriorityComponent"
		[attr.data-testid]="'priorityRadio/' + MessagePurpose.PROMOTION"
		[componentData]="MessagePurpose.PROMOTION"
		[formControl]="control"
		[id]="'Promotion'"
		[value]="MessagePurpose.PROMOTION"
		name="priority"
	>
		{{ 'enums.' + MessagePurpose.PROMOTION | translate }}
	</alaris-radio>
</div>
